module.exports = vendor_02c370adb2b673714c9f;